import React from 'react';
import IconButton from '../../../icon-button';
import DialogHeaderControl from '../dialog-header-control';
import { APPEARANCES, SIZES } from '../../../icon-button/constants';
import { DialogHeaderIconButtonProps } from './types';

const DialogHeaderIconButton = (props) => (
  <DialogHeaderControl>
    <IconButton {...props} appearance={APPEARANCES.light} transparent size={SIZES.medium} />
  </DialogHeaderControl>
);

DialogHeaderIconButton.propTypes = DialogHeaderIconButtonProps;

export default DialogHeaderIconButton;
